module.exports = __webpack_public_path__ + "static/media/best-buy_2x.50448bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/best-buy_2x.jpg
// module id = 744
// module chunks = 27